module.exports = __webpack_public_path__ + "static/media/rhr.b64928d6.JPG";